// Footer.js
import React from 'react';
import './UserCSS/custom.css'; // Import custom CSS for additional styling

function Footer() {
  return (
    <footer className="text-center mt-4 full-width-footer" style={{ backgroundColor: '#333', color: '#fff', height: '150px' }}>
      <p className="p-3">© {new Date().getFullYear()} Manipal Dot Net</p>
      <p>
        Powered by <a href="https://www.manipal.net" style={{ color: '#fff' }}>www.manipal.net</a>
      </p>
    </footer>
  );
}

export default Footer;
